import { render, staticRenderFns } from "./OfficerPerformance.vue?vue&type=template&id=1b4b4fac"
import script from "./OfficerPerformance.vue?vue&type=script&lang=js"
export * from "./OfficerPerformance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports